import type { LibraryReferenceAliases } from './library-identity-types';

export const LIBRARY_REFERENCE_ALIASES: LibraryReferenceAliases = {
  "barbell-flat-press": ["library-barbell-flat-press"],
  "ksw-chest-bench-press-compressed": ["library-barbell-flat-press"],
  "cable-crossover": ["library-cable-crossover"],
  "push-up": ["library-push-up"],
  "home-dumbbell-pushup": ["library-home-dumbbell-pushup"],
  "home-dumbbell-flat-press": ["library-home-dumbbell-flat-press"],
  "home-dumbbell-fly": ["library-home-dumbbell-fly"],
  "ksw-dips": ["library-ksw-dips"],
  "threeway-dips": ["library-ksw-dips"],
  "threeway-machine-fly": ["library-threeway-machine-fly"],
  "threeway-flat-machine-press": ["library-threeway-flat-machine-press"],
  "personal-s4-seated-flat-press": ["library-threeway-flat-machine-press"],
  "threeway-decline-cable-fly": ["library-threeway-decline-cable-fly"],
  "personal-s4-cable-upper-chest": ["library-personal-s4-cable-upper-chest"],
  "fanjue-incline-barbell-press": ["library-fanjue-incline-barbell-press"],
  "fanjue-incline-smith-press": ["library-fanjue-incline-barbell-press"],
  "fanjue-incline-machine-chest-press": ["library-fanjue-incline-machine-chest-press"],
  "incline-bench-row": ["library-incline-bench-row"],
  "home-single-arm-dumbbell-row": ["library-home-single-arm-dumbbell-row"],
  "home-double-dumbbell-bent-row": ["library-home-double-dumbbell-bent-row"],
  "home-pull-up": ["library-home-pull-up"],
  "ksw-single-arm-cable-pulldown": ["library-ksw-single-arm-cable-pulldown"],
  "ksw-single-arm-machine-row": ["library-ksw-single-arm-machine-row"],
  "ksw-wide-grip-row": ["library-ksw-wide-grip-row"],
  "ksw-back-extension": ["library-ksw-back-extension"],
  "threeway-neutral-pulldown": ["library-threeway-neutral-pulldown"],
  "threeway-supinated-pulldown": ["library-threeway-supinated-pulldown"],
  "threeway-narrow-cable-row": ["library-threeway-narrow-cable-row"],
  "fanjue-seated-cable-row": ["library-threeway-narrow-cable-row"],
  "threeway-tbar-row": ["library-threeway-tbar-row"],
  "threeway-bent-barbell-row": ["library-threeway-bent-barbell-row"],
  "personal-s2-straight-arm-pulldown": ["library-personal-s2-straight-arm-pulldown"],
  "fanjue-straight-arm-pulldown": ["library-personal-s2-straight-arm-pulldown"],
  "personal-s2-single-arm-cable-row": ["library-personal-s2-single-arm-cable-row"],
  "fanjue-wide-pulldown": ["library-fanjue-wide-pulldown"],
  "fanjue-prone-machine-row": ["library-fanjue-prone-machine-row"],
  "fanjue-supinated-straight-arm-pulldown": ["library-fanjue-supinated-straight-arm-pulldown"],
  "fanjue-seated-machine-row": ["library-fanjue-seated-machine-row"],
  "fanjue-lat-pulldown": ["library-fanjue-lat-pulldown"],
  "prone-dumbbell-fly": ["library-prone-dumbbell-fly"],
  "cable-face-pull": ["library-cable-face-pull"],
  "threeway-behind-neck-tricep": ["library-cable-face-pull"],
  "home-prone-reverse-fly": ["library-home-prone-reverse-fly"],
  "home-seated-dumbbell-rear-fly": ["library-home-seated-dumbbell-rear-fly"],
  "home-seated-dumbbell-press": ["library-home-seated-dumbbell-press"],
  "personal-s5-dumbbell-shoulder-press": ["library-home-seated-dumbbell-press"],
  "ksw-y-raise": ["library-ksw-y-raise"],
  "threeway-lateral-raise": ["library-threeway-lateral-raise"],
  "personal-s5-lateral-raise": ["library-threeway-lateral-raise"],
  "threeway-seated-reverse-fly": ["library-threeway-seated-reverse-fly"],
  "threeway-cable-reverse-fly": ["library-threeway-cable-reverse-fly"],
  "personal-s2-cable-reverse-fly": ["library-threeway-cable-reverse-fly"],
  "threeway-smith-press": ["library-threeway-smith-press"],
  "personal-s4-shoulder-work": ["library-personal-s4-shoulder-work"],
  "personal-s5-bent-over-rear-delt": ["library-personal-s5-bent-over-rear-delt"],
  "fanjue-external-rotation-press": ["library-fanjue-external-rotation-press"],
  "fanjue-rear-delt-bodyweight": ["library-fanjue-rear-delt-bodyweight"],
  "fanjue-supine-face-pull": ["library-fanjue-supine-face-pull"],
  "fanjue-standing-military-press": ["library-fanjue-standing-military-press"],
  "fanjue-dumbbell-front-raise": ["library-fanjue-dumbbell-front-raise"],
  "barbell-bicep-curl": ["library-barbell-bicep-curl"],
  "kneel-tricep-dip": ["library-kneel-tricep-dip"],
  "supine-cable-tricep": ["library-supine-cable-tricep"],
  "seated-cable-curl": ["library-seated-cable-curl"],
  "behind-neck-cable-tricep": ["library-behind-neck-cable-tricep"],
  "home-bent-tricep-kickback": ["library-home-bent-tricep-kickback"],
  "home-seated-behind-neck-tricep": ["library-home-seated-behind-neck-tricep"],
  "home-dumbbell-curl": ["library-home-dumbbell-curl"],
  "ksw-lying-extension": ["library-ksw-lying-extension"],
  "threeway-barbell-skull-crusher": ["library-ksw-lying-extension"],
  "ksw-cable-curl": ["library-ksw-cable-curl"],
  "threeway-bench-dip": ["library-threeway-bench-dip"],
  "personal-s2-cable-tricep-pushdown": ["library-personal-s2-cable-tricep-pushdown"],
  "personal-s8-cable-tricep-pushdown": ["library-personal-s2-cable-tricep-pushdown"],
  "personal-s3-supine-dumbbell-curl": ["library-personal-s3-supine-dumbbell-curl"],
  "personal-s3-overhead-tricep": ["library-personal-s3-overhead-tricep"],
  "personal-s3-internal-rotation-curl": ["library-personal-s3-internal-rotation-curl"],
  "fanjue-elbow-extension-tricep": ["library-fanjue-elbow-extension-tricep"],
  "fanjue-bent-barbell-curl": ["library-fanjue-bent-barbell-curl"],
  "fanjue-single-arm-cable-tricep": ["library-fanjue-single-arm-cable-tricep"],
  "fanjue-straight-bar-tricep": ["library-fanjue-straight-bar-tricep"],
  "fanjue-cable-hammer-curl": ["library-fanjue-cable-hammer-curl"],
  "bulgarian-split-squat": ["library-bulgarian-split-squat"],
  "fanjue-bulgarian-glute": ["library-bulgarian-split-squat"],
  "single-leg-dumbbell-dl": ["library-single-leg-dumbbell-dl"],
  "single-leg-dl-glute": ["library-single-leg-dumbbell-dl"],
  "dumbbell-lunge": ["library-dumbbell-lunge"],
  "standing-calf-raise": ["library-standing-calf-raise"],
  "home-bulgarian-split-squat-v2": ["library-home-bulgarian-split-squat-v2"],
  "ksw-single-leg-bulgarian": ["library-home-bulgarian-split-squat-v2"],
  "threeway-bulgarian-squat": ["library-home-bulgarian-split-squat-v2"],
  "fanjue-bulgarian-leg": ["library-home-bulgarian-split-squat-v2"],
  "home-glute-bridge-v2": ["library-home-glute-bridge-v2"],
  "home-goblet-squat": ["library-home-goblet-squat"],
  "ksw-barbell-rdl": ["library-ksw-barbell-rdl"],
  "threeway-lying-leg-curl": ["library-threeway-lying-leg-curl"],
  "threeway-rhino-squat": ["library-threeway-rhino-squat"],
  "personal-s6-adductor": ["library-personal-s6-adductor"],
  "personal-s6-bulgarian-squat": ["library-personal-s6-bulgarian-squat"],
  "fanjue-bulgarian-squat": ["library-personal-s6-bulgarian-squat"],
  "personal-s6-dumbbell-rdl": ["library-personal-s6-dumbbell-rdl"],
  "personal-s6-hip-flexor-raise": ["library-personal-s6-hip-flexor-raise"],
  "fanjue-side-band-walk": ["library-fanjue-side-band-walk"],
  "fanjue-wide-body-function": ["library-fanjue-wide-body-function"],
  "fanjue-seated-leg-extension": ["library-fanjue-seated-leg-extension"],
  "home-side-plank-v2": ["library-home-side-plank-v2"],
  "fanjue-copenhagen-plank": ["library-home-side-plank-v2"],
  "personal-s7-hanging-leg-raise": ["library-personal-s7-hanging-leg-raise"],
  "personal-s7-crunch": ["library-personal-s7-crunch"],
  "personal-s7-ab-wheel": ["library-personal-s7-ab-wheel"],
  "fanjue-reverse-hyperextension-crunch": ["library-fanjue-reverse-hyperextension-crunch"],
  "fanjue-cable-crunch-kneeling": ["library-fanjue-cable-crunch-kneeling"],
  "fanjue-cable-twist": ["library-fanjue-cable-twist"],
  "band-shoulder-warmup": ["library-band-shoulder-warmup"],
  "band-shoulder-pull": ["library-band-shoulder-warmup"],
  "wall-scapular-protraction": ["library-wall-scapular-protraction"],
  "hip-adductor-machine": ["library-hip-adductor-machine"],
  "side-lying-hip-adduct": ["library-side-lying-hip-adduct"],
  "side-lunge-stretch": ["library-side-lunge-stretch"],
  "home-band-chest-activate": ["library-home-band-chest-activate"],
  "home-wall-handstand": ["library-home-wall-handstand"],
  "home-prone-back-extension": ["library-home-prone-back-extension"],
  "home-worlds-greatest-stretch": ["library-home-worlds-greatest-stretch"],
  "home-prone-y-raise": ["library-home-prone-y-raise"],
  "ksw-warmup-pec-minor-release": ["library-ksw-warmup-pec-minor-release"],
  "ksw-warmup-pec-major-release": ["library-ksw-warmup-pec-major-release"],
  "ksw-warmup-biceps-release": ["library-ksw-warmup-biceps-release"],
  "ksw-warmup-lower-trap-y": ["library-ksw-warmup-lower-trap-y"],
  "ksw-warmup-serratus-activation": ["library-ksw-warmup-serratus-activation"],
  "ksw-warmup-wrist-activation": ["library-ksw-warmup-wrist-activation"],
  "ksw-warmup-band-shoulder-circles": ["library-ksw-warmup-band-shoulder-circles"],
  "ksw-warmup-thoracic-flexion": ["library-ksw-warmup-thoracic-flexion"],
  "ksw-warmup-thoracic-proprioception": ["library-ksw-warmup-thoracic-proprioception"],
  "ksw-warmup-dynamic-frog": ["library-ksw-warmup-dynamic-frog"],
  "ksw-warmup-hip-90-90": ["library-ksw-warmup-hip-90-90"],
  "ksw-warmup-ankle-activation": ["library-ksw-warmup-ankle-activation"],
  "ksw-warmup-foam-calf": ["library-ksw-warmup-foam-calf"],
  "ksw-warmup-foam-quad": ["library-ksw-warmup-foam-quad"],
  "ksw-warmup-foam-glute": ["library-ksw-warmup-foam-glute"],
  "ksw-warmup-foam-tfl": ["library-ksw-warmup-foam-tfl"],
  "ksw-warmup-foam-tibialis": ["library-ksw-warmup-foam-tibialis"],
  "threeway-shoulder-warmup": ["library-threeway-shoulder-warmup"],
  "threeway-back-warmup": ["library-threeway-back-warmup"],
  "threeway-dumbbell-shoulder-activation": ["library-threeway-dumbbell-shoulder-activation"],
  "personal-s2-prep": ["library-personal-s2-prep"],
  "personal-s2-ab-wheel-foam": ["library-personal-s2-ab-wheel-foam"],
  "personal-s5-trx-activation": ["library-personal-s5-trx-activation"],
  "fanjue-scapular-activation": ["library-fanjue-scapular-activation"],
  "fanjue-standing-chest-shoulder-stretch": ["library-fanjue-standing-chest-shoulder-stretch"],
  "fanjue-elbow-bench-stretch": ["library-fanjue-elbow-bench-stretch"],
  "fanjue-spider-warmup": ["library-fanjue-spider-warmup"],
  "fanjue-head-ground-press": ["library-fanjue-head-ground-press"],
  "fanjue-stretch-counter": ["library-fanjue-stretch-counter"],
  "fanjue-foam-roller-support": ["library-fanjue-foam-roller-support"],
  "fanjue-internal-rotation-activation": ["library-fanjue-internal-rotation-activation"],
  "fanjue-kneeling-pushup": ["library-fanjue-kneeling-pushup"],
  "fanjue-rotator-cuff-activation": ["library-fanjue-rotator-cuff-activation"],
  "fanjue-chest-warmup": ["library-fanjue-chest-warmup"],
  "fanjue-gluteus-minimus-activation": ["library-fanjue-gluteus-minimus-activation"],
  "fanjue-leg-warmup": ["library-fanjue-leg-warmup"],
  "personal-s1-chest-stretch": ["library-personal-s1-chest-stretch"],
  "personal-s1-posterior-delt-stretch": ["library-personal-s1-posterior-delt-stretch"],
  "personal-s1-anterior-delt-stretch": ["library-personal-s1-anterior-delt-stretch"],
  "personal-s1-back-tricep-stretch": ["library-personal-s1-back-tricep-stretch"],
  "personal-s1-rhomboid-stretch": ["library-personal-s1-rhomboid-stretch"],
  "personal-s1-bicep-stretch": ["library-personal-s1-bicep-stretch"],
  "personal-s1-abs-oblique-stretch": ["library-personal-s1-abs-oblique-stretch"],
  "personal-s1-glute-stretch": ["library-personal-s1-glute-stretch"],
  "personal-s1-hamstring-stretch": ["library-personal-s1-hamstring-stretch"],
  "personal-s1-quad-stretch": ["library-personal-s1-quad-stretch"],
  "personal-s1-calf-stretch": ["library-personal-s1-calf-stretch"],
  "personal-s1-levator-scap-stretch": ["library-personal-s1-levator-scap-stretch"],
  "personal-s1-sternocleidomastoid": ["library-personal-s1-sternocleidomastoid"],
  "personal-s1-scalene-release": ["library-personal-s1-scalene-release"],
  "personal-s1-platysma-stretch": ["library-personal-s1-platysma-stretch"],
  "personal-s8-barbell-supine-standing": ["library-ksw-lying-extension", "library-barbell-bicep-curl"],
};
